import React from 'react';
import className from 'classnames';
import {
  Icon,
  USER_INTERFACE_ARROW_04_UP,
  USER_INTERFACE_ARROW_04_DOWN,
} from '@bwoty-web/styleguide';

import './FaqHit.scss';

const FaqHit = ({ expanded, toggleExpand, hit }) => {
  return (
    <div
      className={className('web-result-algolia-faq-hit', {
        'web-result-algolia-faq-hit--expanded': expanded,
      })}
      onClick={() => toggleExpand(hit.objectID)}
      role="button"
      tabIndex="0"
      onKeyPress={(e) => {
        if (e.keyCode === 0) {
          toggleExpand(hit.objectID);
        }
      }}
    >
      <div className="web-result-algolia-faq-hit__content">
        <div className="web-result-algolia-faq-hit__content-title">{hit.title}</div>
        <Icon
          className="web-result-algolia-faq-hit__content-icon"
          path={expanded ? USER_INTERFACE_ARROW_04_UP : USER_INTERFACE_ARROW_04_DOWN}
          size="xxs"
        />
      </div>
      {expanded && (
        <div
          className="web-result-algolia-faq-hit__answer"
          onClick={(e) => {
            e.stopPropagation();
          }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: hit.content }}
          role="presentation"
        />
      )}
    </div>
  );
};

export default FaqHit;
